import {
  Component,
  Input,
  OnChanges,
  SimpleChanges
} from '@angular/core';
import {
  ApexAxisChartSeries,
  ApexChart,
  ApexDataLabels,
  ApexPlotOptions,
  ApexStroke,
  ApexXAxis,
  ApexYAxis,
  ApexLegend,
  ApexGrid,
  ApexFill,
  ApexTooltip,
  ApexStates
} from 'ng-apexcharts';
import { NgApexchartsModule } from 'ng-apexcharts';

@Component({
  selector: 'app-bar-chart-one',
  imports: [NgApexchartsModule],
  templateUrl: './bar-chart-one.component.html',
  styles: ``
})
export class BarChartOneComponent implements OnChanges {
  @Input() series: ApexAxisChartSeries = [
    {
      name: 'Total',
      data: [205, 220, 335, 270, 305, 255, 315]
    },
    {
      name: 'Successful',
      data: [145, 160, 265, 185, 220, 165, 235]
    },
    {
      name: 'Failed',
      data: [22, 18, 35, 14, 24, 18, 40]
    }
  ];
  @Input() labels: string[] = [
    'May 14',
    'May 15',
    'May 16',
    'May 17',
    'May 18',
    'May 19',
    'May 20'
  ];
  @Input() colors: string[] = [
    '#465FFF', // Total
    '#22C55E', // Success
    '#EF4444', // Failed
  ];
  @Input() stacked = false;
  @Input() height = 350;
  @Input() columnWidth = '55%';
  @Input() minWidth = 900;
  @Input() distributed = false;
  @Input() legendPosition: 'top' | 'bottom' = 'top';

  public chart: ApexChart = {
    type: 'bar',
    height: this.height,
    stacked: false,
    toolbar: {
      show: false
    },
    fontFamily: '"Inter", sans-serif'
  };

  public plotOptions: ApexPlotOptions = {
    bar: {
      horizontal: false,
      columnWidth: this.columnWidth,
      distributed: this.distributed,
      borderRadius: 6,
      borderRadiusApplication: 'end'
    }
  };

  public dataLabels: ApexDataLabels = {
    enabled: false,
  };

  public stroke: ApexStroke = {
    show: true,
    width: 4,
    colors: ['transparent'],
  };

  public xaxis: ApexXAxis = {
    categories: this.labels,
    axisBorder: {
      show: false
    },
    axisTicks: {
      show: false
    },
    labels: {
      style: {
        colors: '#94A3B8'
      }
    },
    crosshairs: {
      show: false
    }
  };

  public yaxis: ApexYAxis = {
    title: {
      text: undefined,
    }
  };

  public legend: ApexLegend = {
    show: true,
    position: this.legendPosition,
    horizontalAlign: 'left',
    labels: {
      colors: '#94A3B8'
    }
  };

  public grid: ApexGrid = {
    borderColor: '#1E293B',
    strokeDashArray: 4,
    yaxis: {
      lines: {
        show: true
      }
    }
  };

  public fill: ApexFill = {
    type: 'gradient',
    gradient: {
      shade: 'dark',
      type: 'vertical',
      shadeIntensity: 0.5,
      gradientToColors: ['#8092FF', '#4ADE80', '#F87171'],
      inverseColors: false,
      opacityFrom: 1,
      opacityTo: 0.9,
      stops: [0, 100]
    }
  };

  public tooltip: ApexTooltip = {
    theme: 'dark',
    x: {
      show: false,
    },
    y: {
      formatter: (val: number) => `${val}`,
    }
  };

  public states: ApexStates = {
    hover: {
      filter: {
        type: 'none',

      }
    },
    active: {
      filter: {
        type: 'none',

      }
    }
  };

  ngOnChanges(changes: SimpleChanges): void {
    this.xaxis = {
      ...this.xaxis,
      categories: this.labels
    };
    if (changes['stacked'] || changes['height']) {
      this.chart = {
        ...this.chart,
        stacked: this.stacked,
        height: this.height
      };
    }
    if (changes['columnWidth'] || changes['distributed']) {
      this.plotOptions = {
        ...this.plotOptions,
        bar: {
          ...this.plotOptions.bar,
          columnWidth: this.columnWidth,
          distributed: this.distributed
        }
      };
    }
    if (changes['legendPosition']) {
      this.legend = {
        ...this.legend,
        position: this.legendPosition
      };
    }
    if (changes['colors']) {
      this.fill = {
        ...this.fill,
        gradient: {
          ...(this.fill as any).gradient,
          gradientToColors: this.colors.map(c => c + '99')
        }
      };
    }
  }
}
